import React, { useEffect, useState } from 'react';
import api from '../services/api';
import '../css/requisition-app-styles.css';
import { Link } from 'react-router-dom';
import TopBarIcons from './TopBarIcons';
import axios from 'axios';
import RequisitionSubmissionSuccessMessage from './RequisitionSubmissionSuccessMessage';
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Sidebar from './Sidebar';
//import '../css/ViewRequisition.css';


    
    
    const districts = [
      "Balaka", "Blantyre", "Chikwawa", "Chiradzulu", "Chitipa", "Dedza", "Dowa", "Karonga", "Kasungu",
      "Likoma", "Lilongwe", "Machinga", "Mangochi", "Mchinji", "Mulanje", "Mwanza", "Mzimba", "Neno",
      "Nkhata Bay", "Nkhotakota", "Nsanje", "Ntcheu", "Ntchisi", "Phalombe", "Rumphi", "Salima", "Thyolo", "Zomba"
    ];
    
    
    const Settings = () => {

        const firstName = localStorage.getItem('theFirstName'); 
        const lastName = localStorage.getItem('theLastName'); 
        const fullName = firstName + " " + lastName;

        const theUserType = localStorage.getItem('userType');
        const theUserId = localStorage.getItem('userId');  
        const theSupervisorName = localStorage.getItem('supervisorName');  
        const theStaffLevel = localStorage.getItem('staffLevel');    
        const thePhoneNumber = localStorage.getItem('phoneNumber');    

        const [currentRequisitionsOnDate, setCurrentRequisitionsOnDate] = useState(0);

        
    
        const [formData, setFormData] = useState({
          country: '',
          district: '',
          projectCode: '',
          budgetLineCode: '',
          projectName: '',
          payMode: '',
          bankName: '',
          branch: '',
          accountNumber: '',
          phoneNumber: '',
          requisitionDate: '',
          requisitionID: '',
          status: 'Draft',
          costDrivers: [],
          userId: theUserId,  
        });

        useEffect(() => {
          const theUserId = localStorage.getItem("userId"); 
          if (theUserId) {
            setFormData((prevState) => ({
              ...prevState,
              userId: theUserId, 
            }));
          }
        }, []); 
        

        const generateRequisitionID = (firstName, lastName, phoneNumber, currentRequisitionsOnDate) => {
          const today = new Date();
          const year = today.getFullYear().toString().slice(-2);
          const month = (today.getMonth() + 1).toString().padStart(2, '0');
          const day = today.getDate().toString().padStart(2, '0');
          const initials = `${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}`;
          const requisitionNumber = (currentRequisitionsOnDate + 1).toString().padStart(2, '0');
          return `${initials}${year}${month}${day}${phoneNumber}${requisitionNumber}`;
        };

        

          
        
        
        const status = "Draft";
      
        const handleFieldChange = (e) => {
          setFormData({
            ...formData,
            [e.target.name]: e.target.value
          });
        };
        
             
          const [costItems, setCostItems] = useState([
            { costDriver: '', justification: '', quantity: '', unitPrice: '', total: '', supportDocuments: '', quantityTotal: '', unitPriceTotal: '', totalTotal: '' }
          ]);

          const [quantityTotal, setQuantityTotal] = useState(0);
          const [unitPriceTotal, setUnitPriceTotal] = useState(0);
          const [totalTotal, setTotalTotal] = useState(0); 





          useEffect(() => {

            const newQuantityTotal = costItems.reduce((acc, item) => acc + Number(item.quantity || 0), 0);
            const newUnitPriceTotal = costItems.reduce((acc, item) => acc + Number(item.unitPrice || 0), 0);
            const newTotalTotal = costItems.reduce((acc, item) => acc + (Number(item.quantity || 0) * Number(item.unitPrice || 0)), 0);
          
            setQuantityTotal(newQuantityTotal);
            setUnitPriceTotal(newUnitPriceTotal);
            setTotalTotal(newTotalTotal);
          }, [costItems]); 
          
          
          const handleInputChange = (index, field, value) => {
            const newItems = [...costItems];
            newItems[index][field] = value;
        
            if (field === 'quantity' || field === 'unitPrice') {
                const quantity = Number(newItems[index].quantity || 0);
                const unitPrice = Number(newItems[index].unitPrice || 0);
                const total = quantity * unitPrice;
                newItems[index].total = total; 
            }
        
            setCostItems(newItems);
        
            const newQuantityTotal = newItems.reduce((acc, item) => acc + Number(item.quantity || 0), 0);
            const newUnitPriceTotal = newItems.reduce((acc, item) => acc + Number(item.unitPrice || 0), 0);
            const newTotalTotal = newItems.reduce((acc, item) => acc + (Number(item.quantity || 0) * Number(item.unitPrice || 0)), 0);
        
            setQuantityTotal(newQuantityTotal);
            setUnitPriceTotal(newUnitPriceTotal);
            setTotalTotal(newTotalTotal);
        
            console.log("Updated Cost Items:", newItems); 
            console.log("Updated Totals:", newQuantityTotal, newUnitPriceTotal, newTotalTotal);
        };
        
                          
          
          
          
          
          
          
          const handleAddRow = () => {
            setCostItems([
              ...costItems, 
              { costDriver: '', justification: '', quantity: '', unitPrice: '', total: '', supportDocuments: '', quantityTotal: '', unitPriceTotal: '', totalTotal: '' }
            ]);
          };
          
          
          const [submissionStatus, setSubmissionStatus] = useState('Draft');

          const handleSubmit = async (e) => {
            e.preventDefault();
          
            try {
              const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/ActivityProjectAdvanceDetails`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(formData), 
              });
          
              if (response.ok) {
                alert("Details saved successfully!");
              } else {
                alert("Failed to save details.");
              }
            } catch (error) {
              console.error("Error saving details:", error);
            }
          };
                      
        const formatCurrency = (value) => {
            if (!value || value === 0) {
              return ''; 
            }
            return `MK ${Number(value).toLocaleString('en-US')}`;
          };

        const formatQuantityTotal = (value) => {
            if (!value || value === 0) {
              return ''; 
            }
            return ` ${Number(value).toLocaleString('en-US')}`;
        };

           
        const handleDistrictChange = (selectedOption) => {
          setFormData({
            ...formData,
            district: selectedOption ? selectedOption.value : ""
          });
        };
      
        const districtOptions = districts.map((district) => ({
          value: district,
          label: district
        }));

        const navigate = useNavigate(); 

        const handleChangePasswordClick = () => {
          navigate('/settings/change-password'); 
        };
        const handleRequisitionFormAutoFillClick= () => {
          console.log("Requisition Form Auto-fill clicked");

          navigate('/settings'); 
        };

        useEffect(() => {
          if (submissionStatus === "Submitted") {
            navigate("/success"); 
          }
        }, [submissionStatus, navigate]);

    return (
      <div>
      {submissionStatus === "Submitted" ? (
        <RequisitionSubmissionSuccessMessage />
      ) : (
    
      
        <div id="wrapper">
          {/* Sidebar */}
          <Sidebar userType={theUserType} />



{/* Content Wrapper */}

<div id="content-wrapper" className="d-flex flex-column">

    {/* Main Content */}
    <div id="content">
    {/* Topbar */}
    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

    {/* Sidebar Toggle */}
    <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
        <i className="fa fa-bars"></i>
    </button>

    {/* Topbar Search */}
    <form onSubmit={handleSubmit} className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
        <div className="input-group">
            <input type="text" className="form-control bg-light border-0 small" placeholder="Search"
                aria-label="Search" aria-describedby="basic-addon2" />
            <div className="input-group-append">
                <button className="btn btn-primary" type="button">
                    <i className="fas fa-search fa-sm"></i>
                </button>
            </div>
        </div>
    </form>

    {/* Topbar Navbar */}
    <ul className="navbar-nav ml-auto">

        <TopBarIcons />
        
        

    </ul>

    </nav>
    {/* End of Topbar */}

        {/* Begin Page Content */}
        <div className="container-fluid">
       
        <form onSubmit={handleSubmit}>
          <div className="form-group" >
            <div className="view-requisition-header">
                <Link className="nav-link" to="/requisitions">
                  <i className="fas fa-arrow-left back-button"></i> {/* Back */}
                </Link>
                <h1 className="form-heading h3 mb-4 text-gray-800">Settings</h1>
            </div>
       
                
                <div className="staff-activity-container">
                    <div className="form-group">
                      
                        <br/><br/>
                        <button type="button"  className="settings-buttons" onClick={handleRequisitionFormAutoFillClick}>
                          Requisition Form Auto-fill 
                          <i id="settings-icon-two" className="fas fa-angle-right settings-icons"></i>
                          </button> <br/><br/>
                        <button type="button" className="settings-buttons" onClick={handleChangePasswordClick}>
                          Change Password
                          <i id="settings-icon-three" className="fas fa-angle-right settings-icons"></i>
                        </button>
                      </div>
                
                    <div className="form-group">
                      <h3>Activity Details</h3>
                      <div className="form-field">
                        <label>Country</label>
                        <input
                          type="text"
                          name="country"
                          value={formData.country}
                          onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                        />
                      </div>
                      <div className="form-field">
                        <label>District</label>
                        <Select
                          options={districtOptions}
                          value={districtOptions.find(option => option.value === formData.district)} 
                          onChange={handleDistrictChange} 
                          placeholder="Select District"
                          isClearable
                          className="custom-select-control" 
                        />
                        </div>
                      
                      <div className="form-field">
                        <label>Hub Office</label>
                        <input
                          type="text"
                          name="hubOffice"
                          value={formData.hubOffice}
                          onChange={(e) => setFormData({ ...formData, hubOffice: e.target.value })}
                        />
                      </div>
                    </div>

           
                  <div className="form-group">
                    <h3>Project & Advance Details</h3>
                    <div className="form-field">
                      <label>Project Code</label>
                      <input
                        type="text"
                        name="projectCode"
                        value={formData.projectCode}
                        onChange={(e) => setFormData({ ...formData, projectCode: e.target.value })}
                      />
                    </div>
                    <div className="form-field">
                      <label>Project Name</label>
                      <input
                        type="text"
                        name="projectName"
                        value={formData.projectName}
                        onChange={(e) => setFormData({ ...formData, projectName: e.target.value })}
                      />
                    </div>
                    <div className="form-field">
                      <label>Budget Line Code</label>
                      <input
                        type="text"
                        name="budgetLineCode"
                        value={formData.budgetLineCode}
                        onChange={(e) => setFormData({ ...formData, budgetLineCode: e.target.value })}
                      />
                    </div>
                    <div className="form-field">
                      <label>Pay Mode</label>
                      <select
                        name="payMode"
                        value={formData.payMode}
                        onChange={(e) => setFormData({ ...formData, payMode: e.target.value })}
                      >
                        <option value="">Select Pay Mode</option>
                        <option value="Bank">Bank</option>
                        <option value="Airtel Money">Airtel Money</option>
                        <option value="TNM Mpamba">TNM Mpamba</option>
                        <option value="cash">Cash</option>
                      </select>
                    </div>

                    {formData.payMode === 'Bank' && (
                      <div>
                      <div className="form-field">
                      <label>Bank Name</label>
                      <input
                        type="text"
                        name="bankName"
                        value={formData.bankName}
                        onChange={(e) => setFormData({ ...formData, bankName: e.target.value })}
                      />
                    </div><div className="form-field">
                      <label>Branch</label>
                      <input
                        type="text"
                        name="branch"
                        value={formData.branch}
                        onChange={(e) => setFormData({ ...formData, branch: e.target.value })}
                      />
                    </div>
                      <div className="form-field">
                      <label>Your Account Number</label>
                      <input
                        type="text"
                        name="accountNumber"
                        value={formData.accountNumber}
                        onChange={(e) => setFormData({ ...formData, accountNumber: e.target.value })}
                      />
                    </div>
                    </div>
                    
                )}
                    {(formData.payMode === 'Airtel Money' || formData.payMode === 'TNM Mpamba') && (
                      <div className="form-field">
                        <label>Phone Number</label>
                        <input
                          type="text"
                          name="phoneNumber"
                          value={formData.phoneNumber}
                          onChange={(e) => setFormData({ ...formData, phoneNumber: e.target.value })}
                        />
                      </div>
                    )}
                  </div>
                  </div>
                 





                  <button type="submit" id="submit" className="btn btn-primary">Save Changes</button>

                </div> 

                <div>
                  
                 </div>


        </form>
                
                

 





    </div>
        {/* End of container-fluid */}

  </div>
    {/* End of Main Content */}

    {/* Footer */}
    <footer className="sticky-footer bg-white">
        <div className="container my-auto">
            <div className="copyright text-center my-auto">
                <span>Copyright &copy; Farm Concern International 2025</span>
            </div>
        </div>
    </footer>
    {/* End of Footer */}

</div>


    
    {/* End of Content Wrapper */}


           
          
          
        
      </div>   
    )}

</div>
);
};


export default Settings;